export default (element) => {
    return new Promise((resolve, reject) => {
        if (!!document.querySelector(element)) {
            resolve();
        } else {
            reject();
        }
    });
};
